import styled from 'styled-components';
import { Typography } from '@mui/material';

import colors from '../../../../../../../../styles/colors';

const EmptyState = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  margin: 0;
  padding: 0;
`;

const StyledDate = styled(Typography)`
  color: ${colors.shades.gamma10};
  font-size: 14px;
`;

const StyledDescription = styled(Typography)`
  font-size: 13px;
  padding-top: 8px;
`;

const StyledCard = styled.div`
  margin-left: 6px;
  padding: 16px;
  background-color: ${colors.shades.secondary10};
  border-bottom: 1px solid ${colors.shades.secondary7};
`;

export {
  EmptyState,
  StyledDate,
  StyledDescription,
  StyledCard,
};
